export const styles = {
  select: (theme) => ({
    borderRadius: "8px",
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.primary,
    height: 40,
    maxWidth: "100%",
    "& .MuiSelect-select": {
      py: 0,
      height: 40,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      fontWeight: 600,
      overflow: "hidden",
      // paddingRight: "44px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.divider,
    },
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.light,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.light,
      borderWidth: 1,
    },
    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.main,
      borderWidth: 2,
    },
    "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.main,
    },
    "&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.error.main,
    },
  }),
  placeholder: (theme) => ({
    color: theme.palette.text.disabled,
  }),
  valueText: (theme) => ({
    color: theme.palette.text.primary,
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  }),
  selectWithLabel: {
    height: 52,
    "& .MuiSelect-select": {
      height: 52,
      minHeight: 52,
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: "column",
      gap: 0,
    },
  },
  labelValueStack: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    minWidth: 0,
    width: "100%",
    lineHeight: 1.2,
  },
  selectLabel: (theme) => ({
    color: theme.palette.text.secondary,
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
  }),
  menuItemText: (theme) => ({
    color: theme.palette.text.primary,
  }),
  menuProps: {
    disableScrollLock: true,
    BackdropProps: {
      sx: {
        backgroundColor: "transparent !important",
      },
    },
  },
  loadingIndicator: {
    position: "absolute",
    right: 28,
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
    zIndex: 2,
  },
  loadingIndicatorHidden: {
    visibility: "hidden",
    pointerEvents: "none",
  },
  multiRenderRow: {
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: 0.75,
    overflow: "hidden",
    width: "100%",
  },
  groupHeader: (theme) => ({
    fontWeight: 700,
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.text.secondary,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    lineHeight: "2em",
    bgcolor: theme.palette.background.default,
  }),
  tooltipDiv: {
    display: "block",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  helperText: (theme) => ({
    mx: 0,
    // mt: 0.5,
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.caption.lineHeight,
    minHeight: "1.66em",
  }),
}
